import React, {Component} from "react";
import "./Dealer.scss";
import ContentTemplate from "../ContentTemplate/ContentTemplate";
import imgDealerSequence from "../../assets/images/dealer-report-link-sequence.png";
import imgFourPillars from "../../assets/images/four-pillars.png";
import imgSnapshot from "../../assets/images/snapshot-dealer.png";
import imgSorry from "../../assets/images/sorry-snapshot.png";
import imgRecall from "../../assets/images/ico_recall.svg";
import imgDemoMock from "../../assets/images/carfax-connect-demo-mock.png";
import imgPillarHover from "../../assets/images/accident-pillar-hover.png";
import imgLogoBlack from "../../assets/images/CARFAX_logo_R_black.svg";
import imgLogoWhite from "../../assets/images/CARFAX_logo_R_white.svg";
import LogInMock from "../../assets/images/login-mock.png";
import imgSticker1 from "../../assets/images/window-sticker-1-rev.png"
import imgSticker2 from "../../assets/images/window-sticker-2-rev.png"
import imgSticker3 from "../../assets/images/window-sticker-3-rev.png"
import chbvHistoryArrows from "../../assets/images/chbv_arrows.png";
import purchaseDIR from "../../assets/images/get-dir-after-clicking.png";
import DIRsnapshotAndFourPillars from "../../assets/images/snapshot-and-four-pillars.png";
import Constants from "../Constants";
import {HashLink as Link} from "react-router-hash-link";
import {Image} from "react-bootstrap";
import CodeSnippetTemplate from "../CodeSnippetTemplate/CodeSnippetTemplate";
import CodeSnippet from "../../model/CodeSnippet";
import {CodeSnippetLanguages} from "../CodeSnippetTemplate/CodeSnippetLanguages";
import Table from "react-bootstrap/Table";
import PartnerPortalApplications from "../../assets/images/partner-portal-applications.png";
import PartnerSupportPDF from "../../assets/documents/CARFAX_Partner_Support_FAQs.pdf";
import CollapsibleContent from "../CollapsibleContent/CollapsibleContent";


export default class Dealer extends Component<any, any> {
    private sideNavigationLinks: Map<string, string> = new Map([
        ["#dealer-reports", "Dealer Reports"],
        ["#carfax-report-links", "CARFAX Report Links"],
        ["#four-pillars", "Four Pillars"],
        ["#dealer-snapshot", "Dealer Snapshot"],
        ["#dealer-snapshot-for-stickers", "Dealer Snapshot for Stickers"],
        ["#open-recall-flag", "Open Recall Flag"],
        ["#vehicle-information", "Vehicle Information"],
        ["#connect-caching", "Connect Caching Guidelines"],
        ["#carfax-branding", "CARFAX Branding"],
        ["#carfax-dealer-faqs", "Customer Support FAQs"]
    ]);

    private stoplightNavLinks: Map<string, string> = new Map([
        ["#stoplight-overview", "Overview"],
        ["#stoplight-authentication", "Authentication"],
        ["#stoplight-prerequisites", "Prerequisites"],
        ["#stoplight-sending-request", "Sending a Request"]
    ]);

    private chbvNavLinks: Map<string, string> = new Map([
        ["#chbv-overview", "Overview"],
        ["#chbv-fetch", "Fetch a CARFAX Value"],
        ["#chbv-update", "Update a CARFAX Value"],
        ["#chbv-save", "Save Changes"],
        ["#chbv-errors", "Errors"],
        ["#chbv-style", "Style Guide"],
        ["#chbv-glossary", "Glossary"],
    ]);

    private navLinksMap: Map<string, Map<string, string>> = new Map([
        ["Dealer", this.sideNavigationLinks],
        ["Stoplight", this.stoplightNavLinks],
        ["CARFAX History-Based Value", this.chbvNavLinks],
    ]);

    public render() {
        return (
            <div className={"dealer"}>
                <ContentTemplate
                    pageTitle="Dealer"
                    navlinksMap={this.navLinksMap}
                    content={this.getContentHtml()}
                />
            </div>
        );
    }

    private getContentHtml(): JSX.Element {
        return (
            <div className={"content-container"}>
                <h1 id="dealer">Dealer</h1>
                <section>
                    <h3 id="dealer-reports">Dealer Reports</h3>
                    <p>
                        CARFAX Connect enables dealer facing integration partners to display CARFAX Report links,
                        Snapshot and Four Pillar data from the report.
                    </p>
                    <p>
                        To enable the integration, users must first link their account in the
                        partner application to their CARFAX account. Connect uses&nbsp;
                        <a href={Constants.AUTHENTICATION_PAGE_URL + "#authorization-code-flow"}>
                            OAuth 2 authorization code flow{" "}
                        </a>
                        to let users authorize the partner to access CARFAX Connect on their
                        behalf. When Connect processes a request it identifies the dealer
                        based on the access token sent in the request header.
                    </p>
                    <p>
                        The rules for provisioning CARFAX Reports depend on the dealer's
                        subscription type:
                    </p>
                    <ul>
                        <li>
                            <strong>CARFAX Advantage</strong> dealers receive unlimited CARFAX
                            Reports. They can access a report for any VIN, Snapshot and Pillar
                            data points without a prior explicit purchase.
                        </li>
                        <li>
                            <strong>CARFAX Advantage Limited and Pay-per-VIN</strong> dealers can only
                            access reports for VINs in their CARFAX inventory which represents all reports
                            previously purchased but not yet expired. An explicit purchase request for a VIN
                            is required to add a CARFAX Report to the dealer's inventory.
                        </li>
                        <li>Both dealer types must have an active CARFAX account.</li>
                    </ul>
                    <p>
                        As a host of a dealer facing application, you do not need to know which type of
                        subscription a dealer uses or whether a given VIN is in a dealer's CARFAX inventory,
                        but you do need to be aware of how these provisioning rules interact with the Connect API.
                        There are two ways within Connect to access CARFAX Reports and related data features:
                    </p>
                    <ul>
                        <li>
                            <strong>
                                Query <code>dealerReport</code>
                            </strong>{" "}
                            &mdash; makes a read-only request to get the report only if it is
                            already available.
                            <ul>
                                <li>
                                    <strong>Advantage</strong> dealers will always get the requested
                                    report.
                                </li>
                                <li>
                                    <strong>Advantage Limited and Pay-per-VIN</strong> dealers will get
                                    the report only if the VIN has a pre-existing report in the CARFAX
                                    inventory of reports for the given dealer.
                                    If the VIN is not in the CARFAX inventory you will simply get an <code>errorCode</code> of <code>NO_REPORT_IN_INVENTORY</code>
                                    .
                                </li>
                                <li>
                                    This query can be used to proactively fetch data the user may
                                    want to see and for background refreshes of cached data. It is
                                    always safe to use because it only returns data the dealer is
                                    already allowed to access.
                                </li>
                            </ul>
                        </li>
                        <br/>
                        <li>
                            <strong>
                                Mutation <code>purchaseDealerReportIfRequired</code>
                            </strong>{" "}
                            &mdash; always returns the requested report and adjoining data as provisioned.
                            <ul>
                                <li>
                                    <strong>Advantage</strong> dealers always get the report.
                                </li>
                                <li>
                                    If the request is made for an <strong>Advantage Limited or Pay-per-VIN</strong> dealer
                                    and the VIN is not already in inventory, it will be added and
                                    the dealer will be charged. If the VIN is already in inventory,
                                    the dealer will not be charged again.
                                </li>
                                <li>
                                    The purchase mutation should only be used when the user
                                    performed an action signalling the intent to purchase, such as
                                    clicking a CARFAX Report link.
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <p>
                        Below is an overview of how to use the dealerReport query in combination with the
                        purchaseDealerReportIfRequired mutation to ensure an optimal experience:
                        <ul>
                            <li>
                                Any application intended to only feature a "View CARFAX Report" button or link to run the CARFAX
                                Report may just use the <strong>purchaseDealerReportIfRequired</strong> mutation as all users will get
                                the same experience and there is no need to cache data or perform nightly updates.
                                No need to show an interstitial or pop up message as all users are accustomed to getting
                                the report immediately upon clicking.
                                <br/>
                                <img
                                    width={550}
                                    alt="Get the CARFAX report upo clicking which will purchase a report."
                                    src={purchaseDIR}
                                />
                            </li>
                            <li>
                                All applications where Snapshot and/or Four Pillar data is featured should use a combination
                                of the <strong>dealerReport</strong> query and <strong>purchaseDealerReportIfRequired</strong> mutation.
                                All VINs for a given dealer should be first run through the <strong>dealerReport</strong> query.
                                When successful, all report links, Snapshot keys and Four Pillar data will be available to
                                prepopulate listings.  This feature enables Advantage dealers to quickly benefit from the
                                CARFAX data and Snapshot without having to first click to run the report.
                                For Advantage Limited and Pay-per-VIN users where the report is not already in the CARFAX inventory
                                a NO_REPORT_IN_INVENTORY error code will be returned which is your prompt to use the
                                <strong> purchaseDealerReportIfRequired</strong> mutation should the user click on one of the buttons/links.
                                <br/>
                                <img
                                    width={550}
                                    alt="Dealer snapshot and four pillars on the CARFAX report."
                                    src={DIRsnapshotAndFourPillars}
                                />
                            </li>
                        </ul>
                    </p>
                    <p>
                        If a dealer's CARFAX account is inactive, both the query and mutation
                        will return an error with <code>errorCode</code>{" "}of{" "}
                        <code>INVALID_ACCOUNT</code>.{" "}
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id="carfax-report-links">CARFAX Report Links</h3>
                    <p>
                        All CARFAX Report links can be displayed with the same text or icon
                        regardless of the dealer's subscription type or the VIN's inventory
                        presence. When pay-per-VIN dealers authorize a partner application to
                        use CARFAX they grant permission for report purchases to be made
                        automatically whenever they specifically click on a CARFAX Report.
                        Therefore you can always use the{" "}
                        <code>purchaseDealerReportIfRequired</code>
                        mutation to obtain the report link. Connect will automatically perform
                        the purchase if required before the report link is returned.
                    </p>
                    <p>
                        CARFAX Report links expire. Therefore you should not cache them in
                        advance. Rather, call Connect when the user clicks the report link and
                        redirect the browser to the report URL provided. You can use
                        JavaScript or an actual HTTP redirect from your back end to send the
                        browser to the report URL. Whatever mechanism you use, ensure the
                        redirect is not cached longer than the URL expiration time. If using
                        HTTP redirects, we recommend using status <code>303 See Other</code>{" "}
                        because it will not be cached and forces the browser to make a{" "}
                        <code>GET</code> request to the new URL regardless of the method used
                        in the initial back end request.
                    </p>
                    <p>
                        Sequence for HTTP redirect:
                        <br/>
                        <img
                            alt="Sequence diagram for HTTP redirect for CARFAX link"
                            src={imgDealerSequence}
                        />
                    </p>
                    <p>
                        Example mutation:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `mutation ($vin: Vin!) {
    purchaseDealerReportIfRequired(vin: $vin) {
        dealerReport {
            carfaxLink {
                url
            }
            expiresAt { 
                rfc 
            }
        }
    }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Variables:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify({vin: "19UUA5666YA002236"}, null, 4)
                            )
                        ]}/>
                    </p>
                    <p>
                        Response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        data: {
                                            purchaseDealerReportIfRequired: {
                                                dealerReport: {
                                                    carfaxLink: {
                                                        url: "https://connect.carfax.com/dir?key=oRM754b111ni",
                                                    },
                                                    expiresAt: {
                                                        rfc: "2020-02-20T16:35:55.333Z",
                                                    }
                                                },
                                            },
                                        },
                                    },
                                    null,
                                    4
                                )
                            )
                        ]}/>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id="four-pillars">Four Pillars</h3>
                    <p>
                        Four Pillars is a set of four key characteristics consumers consider
                        when evaluating a vehicle:{" "}
                    </p>
                    <ol id="four-pillars-list">
                        <li>Accidents &amp; damage</li>
                        <li>Owner History (number of owners)</li>
                        <li>Use type (such as personal or commercial)</li>
                        <li>Service Record (number of service records)</li>
                    </ol>
                    <p>
                        Each pillar is represented by an icon and short text description. The
                        Four Pillars should always be displayed in this order.
                    </p>
                    <p>
                        Example Four Pillars display:
                        <br/>
                    </p>
                    <img src={imgFourPillars} width="512px" alt="Example Four Pillars display"/>
                    <p>
                        Enhanced partners can get all 4 pillars. Basic partners can only get
                        the accident/damage and number of owners pillars. Use the interactive
                        schema browser in <a href={Constants.HOME_PAGE_URL + "#connect-explorer"} target="_blank"
                                             rel="noopener noreferrer">Connect Explorer
                    </a> to see which fields are visible to you.
                    </p>
                    <p>
                        Availability of Four Pillars depends on the dealer subscription type:
                    </p>
                    <ul>
                        <li>
                            <strong>Advantage</strong> dealers can get all 4 pillars for any
                            VIN.
                        </li>
                        <li>
                            <strong>Pay-per-vin</strong> dealers can only get 2 pillars:
                            accident/damage and number of owners. Enhanced partners can still
                            query for all 4 pillars; you will simply get <code>null</code> for
                            the use type and service pillars. The data is only provided for VINs
                            in the dealer's CARFAX inventory. If the VIN is not in inventory you
                            will get an error with <code>{`errorCode`}</code>
                            <code>{`NO_REPORT_IN_INVENTORY`}</code>.
                        </li>
                    </ul>
                    <p>
                        <strong><em>Enhanced partners</em></strong> can use the following <code>dealerReport</code>
                        query field to get Four Pillars:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `query ($vin: Vin!) {
    dealerReport(vin: $vin) {
        fourPillars {
            accident {
                iconUrl
                iconText
                position
                hasAccidents
            }
            
            owner {
                iconUrl
                iconText
                position
                isOneOwner
            }
            
            useType {
                iconUrl
                iconText
                position
                isPersonalUse
            }
            
            serviceRecord {
                iconUrl
                iconText
                position
                recordCount
            }
        }
    }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Example response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        data: {
                                            dealerReport: {
                                                fourPillars: {
                                                    accident: {
                                                        iconUrl:
                                                            "https://partnerstatic.carfax.com/img/vhr/ico_alert.svg",
                                                        iconText: "Branded Title",
                                                        position: 1,
                                                        hasAccidents: true,
                                                    },
                                                    owner: {
                                                        iconUrl:
                                                            "https://partnerstatic.carfax.com/img/vhr/ico_owner3.svg",
                                                        iconText: "3+ Owners",
                                                        position: 2,
                                                        isOneOwner: false,
                                                    },
                                                    useType: {
                                                        iconUrl:
                                                            "https://partnerstatic.carfax.com/img/vhr/ico_personal.svg",
                                                        iconText: "Personal Use",
                                                        position: 3,
                                                        isPersonalUse: true,
                                                    },
                                                    serviceRecord: {
                                                        iconUrl:
                                                            "https://partnerstatic.carfax.com/img/vhr/ico_service.svg",
                                                        iconText: "Service History",
                                                        position: 4,
                                                        recordCount: 15,
                                                    },
                                                },
                                            },
                                        },
                                    },
                                    null,
                                    4
                                )
                            )
                        ]}/>
                    </p>
                    <p>
                        <strong><em>Basic partners</em></strong> can use the
                        following <code>dealerReport</code> query
                        field to get Two Pillars:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `query ($vin: Vin!) {
    dealerReport(vin: $vin) {
        fourPillars {
            accident {
            iconUrl
            iconText
            position
            hasAccidents
        }
        owner {
            iconUrl
            iconText
            position
            isOneOwner
        }
    }
  }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Example response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        data: {
                                            dealerReport: {
                                                fourPillars: {
                                                    accident: {
                                                        iconUrl:
                                                            "https://partnerstatic.carfax.com/img/vhr/ico_alert.svg",
                                                        iconText: "Branded Title",
                                                        position: 1,
                                                        hasAccidents: true,
                                                    },
                                                    owner: {
                                                        iconUrl:
                                                            "https://partnerstatic.carfax.com/img/vhr/ico_owner3.svg",
                                                        iconText: "3+ Owners",
                                                        position: 2,
                                                        isOneOwner: false,
                                                    },
                                                },
                                            },
                                        },
                                    },
                                    null,
                                    4
                                )
                            )
                        ]}/>
                    </p>
                    <p>
                        Every pillar has an <code>iconUrl</code> with <code>iconText</code> to
                        display alongside the icon.
                        <code>position</code> is a reminder of the display order but you do
                        not need to query it in your application because the order never
                        changes. The boolean flags <code>hasAccidents</code>,{" "}
                        <code>isOneOwner</code>, <code>isPersonalUse</code>, and the numeric{" "}
                        <code>recordCount</code> can be used to implement sorting and
                        filtering of VIN lists. The service <code>recordCount</code> can be
                        displayed near the service icon if space permits.
                    </p>
                    <p>
                        You can cache Four Pillars for faster display. You should refresh the
                        cached data at least once per day. You can also load it on demand if
                        desired, such as when a user loads a page that displays Four Pillars.
                        Cached data can be shared between users at the same dealer but must
                        not be shared across dealers. In other words, the cache key must
                        include the VIN and dealer ID.
                    </p>
                    <p>
                        You can safely use the <code>dealerReport</code> query to request Four
                        Pillars for every VIN displayed. Connect will take care of checking
                        the dealer subscription and inventory presence to return the
                        appropriate 2 or 4 pillars or <code>NO_REPORT_IN_INVENTORY</code> error.
                    </p>
                    <p>
                        You should not use the <code>purchaseDealerReportIfRequired</code> mutation just to get
                        Four Pillars, as merely displaying the data does not indicate a clear intent to purchase.
                        However, if a user clicks a CARFAX Report link you can retrieve the Four Pillars
                        at the same time as the report link:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `mutation ($vin: Vin!) {
    purchaseDealerReportIfRequired(vin: $vin) {
        dealerReport {
            carfaxLink {
                url
            }
            expiresAt { 
                rfc 
            }
            fourPillars {
                # etc., as above example
            }
        }
    }
}`
                            )
                        ]}/>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id="dealer-snapshot">Dealer Snapshot</h3>
                    <p>
                        Snapshot is a simple html file generated for the client to give a
                        'snapshot' of key vehicle history information. When added to an
                        inventory management tool, Snapshot offers these benefits:
                    </p>
                    <ul>
                        <li>
                            For all vehicles already featuring a Dealer Instant CARFAX Report,
                            dealers may now see the same data found in the header of the
                            report at all places where they engage with the vehicle in your
                            application.
                        </li>
                        <li>
                            With just a hover over the CARFAX logo, dealers can quickly see
                            the key vehicle history points for the given vehicle, allowing
                            them to make timely inventory management decisions.
                        </li>
                        <li>
                            Dealers can reference the CARFAX History-Based Value for their
                            vehicles if your agreement terms provide for this added benefit.{" "}
                        </li>
                    </ul>
                    <img src={imgSnapshot} alt="speSnapshot Example" className={"img-fluid"} width="250px"/>
                    <p>
                        Unlike the legacy Snapshot, the new Snapshot URL has a
                        Snapshot key which hides the VIN and dealer information. Advantage and
                        Pay Per VIN dealers can both request Snapshot. Advantage dealers will
                        always receive Snapshot but Pay Per VIN dealers may only view it if
                        the VIN is already in their inventory. Two approaches can be used to
                        request Snapshot:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `query ($vin: Vin!) {
    dealerReport(vin: $vin) {
        snapshotKey
    }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Variables:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify({vin: "JN8AF5MR5CT116133"}, null, 4)
                            )
                        ]}/>
                    </p>
                    <p>
                        Sample response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        data: {
                                            dealerReport: {
                                                snapshotKey:
                                                    "p5lI0fc6F52ATD-ayqZRUze_I30-6NQVyEahpAADvz4fcqX1kP6rNRvuA2JJBhC1ZDrE1dgeV7M1pBTGCWG3rVJDfY2aWSUvAmp0IpeC6tnf1oxHutKkb3s0jeUmrevT_GnG43aWAbyOlTlueofoE8fF",
                                            },
                                        },
                                    },
                                    null,
                                    4
                                )
                            )
                        ]}/>
                    </p>
                    <p>
                        Purchasing a Dealer Report:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `mutation ($vin: Vin!) {
    purchaseDealerReportIfRequired(vin: $vin) {
        dealerReport {
            snapshotKey
        }
    }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Variables:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify({vin: "JN8AF5MR5CT116133"}, null, 4)
                            )
                        ]}/>
                    </p>
                    <p>
                        Sample Response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        data: {
                                            purchaseDealerReportIfRequired: {
                                                dealerReport: {
                                                    snapshotKey:
                                                        "8D7mVwqG3YTtN8KZuSVCP7niVLsUdH2Vs32jFn9qEUYbssf8olRkBuEe8DtoZaNkp3BXJL4ADy8th5O6gJSxQbM7Q7zC4tFJOq7t45KZdHwEbed2Vu7EppCSgupN5jBmB_V4ZoCzhBA7IA_P1NNYA__k",
                                                },
                                            },
                                        },
                                    },
                                    null,
                                    4
                                )
                            )
                        ]}/>
                    </p>
                    <p>
                        Information such as <code>{`vin`}</code>, <code>{`userId`}</code> and{" "}
                        <code>{`dealerCompCode`}</code>
                        are embedded in the <code>{`snapshotKey`}</code>; which can be used to
                        render the Snapshot data through the dealer Snapshot endpoint. The key
                        is used to ensure that the requests being made against our server are
                        authorized and can also be injected in an img or anchor tag to show
                        the Snapshot html.
                    </p>
                    <h4 id="including-snapshotjs">Including Snapshot.js</h4>
                    <p>
                        When implementing Snapshot, you'll need to use our hosted JavaScript
                        file:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                '<script type="text/javascript" src="https://snapshot.carfax.com/latest/dealer-snapshot.js"></script>'
                            )
                        ]}/>
                    </p>
                    <p>
                        Generally, it should be included right before you close out your body
                        tag in your HTML document.
                    </p>
                    <h4 id="dealer-snapshot-hover-over">Dealer Snapshot Hover-Over</h4>
                    <p>
                        On a desktop application, we recognize that most existing promotions
                        will show simply a CARFAX logo or icon. Hovering over the logo/icon
                        will cause the Snapshot to render just to the side of the logo/icon.
                        Clicking on the logo/icon should open the dealer report directly.{" "}
                    </p>
                    <p>
                        Note that Snapshot is not supported as a hover-over on mobile devices. It is recommended to use
                        the embedded version of Snapshot on a VDP or to simply open the DIR from an SRP link in mobile
                        applications or websites.
                    </p>
                    <p>
                        Applying the bindings for the Snapshot hover-over is as easy as adding
                        only two attributes on your html element that you would like to display
                        Snapshot, when hovered over. The elements are as follows:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                'class="carfax-dealer-snapshot-hover" data-snapshotkey="SnapshotKey"'
                            )
                        ]}/>
                    </p>
                    <p>
                        SnapshotKey = The key you will get back from the
                        Connect Dealer Report Response
                    </p>
                    <p>
                        For example, an Image tag that shows the report when hovered over
                        would follow this pattern.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                '<img src="photo.jpg" class="carfax-dealer-snapshot-hover" data-snapshotkey="SnapshotKey"/>'
                            )
                        ]}/>
                    </p>
                    <h4 id="embedded-dealer-snapshot">Embedded Dealer Snapshot</h4>
                    <p>
                        The Dealer Snapshot may also be embedded on any page of your
                        application for easy presentation of the CARFAX vehicle history.
                        <br/>
                        The embedded Snapshot displays just as the hover-over version,
                        however, it’s not triggered by hovering over an element, and instead,
                        it’s added to the page as it loads. Just like the hover-over version
                        of Snapshot, the embedded version also allows dealers to click “View
                        the CARFAX Report” in order to see the full report.
                    </p>
                    <p>
                        The class for the embedded Snapshot is “carfax-snapshot-embedded”. You
                        will want to include the same JavaScript library whether using the
                        embedded or pop-up version of Snapshot on a page. We also recommend
                        using a <code>{`<div>`}</code> element for the embedded Snapshot to
                        ensure everything is styled appropriately.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                'class="carfax-dealer-snapshot-embedded" data-snapshotkey="SnapshotKey"'
                            )
                        ]}/>
                    </p>
                    <p>
                        SnapshotKey = The key you will get back from the
                        Connect Dealer Report Response
                    </p>
                    <p>
                        For example, an Image tag that shows the report when hovered over
                        would follow this pattern.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                '<div class="carfax-dealer-snapshot-embedded" data-snapshotkey="SnapshotKey"></div>'
                            )
                        ]}/>
                    </p>
                    <h4 id={"refreshing snapshot"}>Refreshing Snapshot</h4>
                    <p>
                        To ensure that Snapshot displays the most up to date data and aligns with what the user sees on
                        the CARFAX Report we recommend
                        you reload the Snapshot.js file when the page reloads. In order to do so, please trigger the
                        'refreshSnapshotEvent' after the
                        Connect data has finished loading.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JAVASCRIPT,
                                "JavaScript",
                                `const refreshSnapshotEvent = new Event('refreshCarfaxSnapshotData');

document.dispatchEvent(refreshSnapshotEvent);`
                            )
                        ]}/>
                    </p>
                    <h4 id="specs">Specs</h4>
                    <p>
                        Snapshot is built to be resized responsively but we do have the
                        following min/max sizes that we suggest you use when rendering
                        Snapshot.
                    </p>
                    <p>
                        If featuring Snapshot with CARFAX History Based Value:
                    </p>
                    <ul>
                        <li>
                            Minimum width = 300 pixels
                        </li>
                        <li>
                            Maximum width = 350 pixels (a user may enlarge it beyond this but
                            the rows will simply stretch)
                        </li>
                        <li>
                            Maximum height = 541 pixels if the Year/Make/Model shows on three
                            lines
                        </li>
                    </ul>
                    <p>
                        If featuring Snapshot without CARFAX History Based Value:
                    </p>
                    <ul>
                        <li>
                            Minimum width = 300 pixels
                        </li>
                        <li>
                            Maximum width = 350 pixels (a user may enlarge it beyond this but
                            the rows will simply stretch)
                        </li>
                        <li>
                            Maximum height = 470 pixels if the Year/Make/Model shows on three
                            lines
                        </li>
                    </ul>
                    <p>
                        Please note that the final implementation of Snapshot in your
                        application shall be mutually agreed to and approved by your CARFAX
                        account manager prior to launch. We encourage you to share screen
                        shots and/or provide beta access to your application to facilitate
                        this process.
                    </p>
                    <h4 id="sorry-message">Sorry Message</h4>
                    <p>
                        Should the report be unavailable, the service be down or the request
                        not properly authenticated, the dealer will receive a “sorry” message
                        like the one below.
                        <br/>
                        <img src={imgSorry} alt="Sorry Page" width="300" height="390"/>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"dealer-snapshot-for-stickers"}>Dealer Snapshot for Stickers</h3>
                    <p>
                        If your application supports the ability for dealers to produce window
                        stickers you may use CARFAX Connect to include Dealer Snapshot on the
                        stickers as a unique way for dealers to carry the CARFAX message on to
                        their vehicles. The Snapshot data shown here is what consumers will see
                        online via Snapshot or the CARFAX Report so dealers are able to offer a
                        consistent message online and offline. Examples of how Snapshot may
                        render on the left rail of a sticker are below:
                        <br/>
                        <img src={imgSticker1} alt="Window Sticker No Accidents" width="275" height="380"/>
                        <img src={imgSticker2} alt="Window Sticker Accidents Reported" width="275" height="380"/>
                        <img src={imgSticker3} alt="Window Sticker Vehicle Reported Stolen" width="275" height="380"/>
                    </p>
                    <p>
                        The request to fetch Snapshot for Stickers checks for a previously run
                        CARFAX Report and if one is not found the report is run for the dealer.
                        Snapshot will typically render six data points but may still show with
                        as few as three rows.  Note that the last reported odometer reading is
                        optional for display on window stickers given the odometer reading is
                        already present on the sticker.
                    </p>
                    <p>
                        If you are provisioned to enable Snapshot on window stickers please
                        use the following query to fetch the data at the time of producing the
                        sticker in your application:
                    </p>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "GraphQL",
                            `query {
  windowSticker(vin: "1C4HJWDG3EL227974") 
}`
                        )
                    ]}/>
                    <p>
                        Sample Response:
                        <CollapsibleContent content={
                            <CodeSnippetTemplate codeSnippets={[
                                new CodeSnippet(
                                    CodeSnippetLanguages.JSON,
                                    "JSON",
                                    JSON.stringify(
                                        {
                                            data: {
                                                windowSticker: {
                                                    items: [
                                                        {
                                                            "text": "Show Me the CARFAX Badge",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/valuebadge/showme.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/valuebadge/showme.png"
                                                        },
                                                        {
                                                            "text": "No accidents or damage reported to CARFAX",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_noAccident.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_noAccident_blk.png",
                                                            "iconKey": "NO_ACCIDENT"
                                                        },
                                                        {
                                                            "text": "3 Previous owners",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_owner3.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_owner3_blk.png",
                                                            "iconKey": "OWNER_3"
                                                        },
                                                        {
                                                            "text": "17 Service history records",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_service.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_service_blk.png",
                                                            "iconKey": "SERVICE"
                                                        },
                                                        {
                                                            "text": "Types of owners: Personal lease, Lease, Personal",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_generic.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_generic_blk.png",
                                                            "iconKey": "GENERIC"
                                                        },
                                                        {
                                                            "text": "Last owned in Pennsylvania",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_stateOwned.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_stateOwned_blk.png",
                                                            "iconKey": "STATE_OWNED"
                                                        },
                                                        {
                                                            "text": "7 Last reported odometer reading",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_odometer.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_odometer_blk.png",
                                                            "iconKey": "ODOMETER"
                                                        }
                                                    ],
                                                    "disclaimer": {
                                                        "text": "Not all accidents or other issues are reported to CARFAX. The number of owners is estimated. See the full CARFAX Report for additional information and glossary of terms. As of Apr 29, 2021.",
                                                        "iconUrl": "https://partnerstatic.carfax.com/img/disclaimer/disclaimer.png",
                                                        "grayIconUrl": "https://partnerstatic.carfax.com/img/disclaimer/disclaimer_blk.png"
                                                    }
                                                },
                                            },
                                        },
                                        null,
                                        4
                                    )
                                )
                            ]}/>}/>
                    </p>
                    <p>
                        If you wish to allow the dealer to first see the CARFAX Report prior to
                        printing you may use the query below to fetch the Dealer report link and
                        Snapshot to render online:
                    </p>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "GraphQL",
                            `query {
  windowSticker(vin: "1C4HJWDG3EL227974") 
  dealerReport(vin: "1C4HJWDG3EL227974"){
    carfaxLink{
      url
    }
    snapshotKey
  }
}`
                        )
                    ]}/>
                    <p>
                        Sample Response:
                        <CollapsibleContent content={
                            <CodeSnippetTemplate codeSnippets={[
                                new CodeSnippet(
                                    CodeSnippetLanguages.JSON,
                                    "JSON",
                                    JSON.stringify(
                                        {
                                            data: {
                                                windowSticker: {
                                                    items: [{
                                                        "text": "Show Me the CARFAX Badge",
                                                        "iconUrl": "https://partnerstatic.carfax.com/img/valuebadge/showme.png",
                                                        "grayIconUrl": "https://partnerstatic.carfax.com/img/valuebadge/showme.png"
                                                    },
                                                        {
                                                            "text": "No accidents or damage reported to CARFAX",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_noAccident.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_noAccident_blk.png",
                                                            "iconKey": "NO_ACCIDENT"
                                                        },
                                                        {
                                                            "text": "3 Previous owners",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_owner3.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_owner3_blk.png",
                                                            "iconKey": "OWNER_3"
                                                        },
                                                        {
                                                            "text": "17 Service history records",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_service.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_service_blk.png",
                                                            "iconKey": "SERVICE"
                                                        },
                                                        {
                                                            "text": "Types of owners: Personal lease, Lease, Personal",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_generic.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_generic_blk.png",
                                                            "iconKey": "GENERIC"
                                                        },
                                                        {
                                                            "text": "Last owned in Pennsylvania",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_stateOwned.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_stateOwned_blk.png",
                                                            "iconKey": "STATE_OWNED"
                                                        },
                                                        {
                                                            "text": "7 Last reported odometer reading",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_odometer.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_odometer_blk.png",
                                                            "iconKey": "ODOMETER"
                                                        }
                                                    ],
                                                    "disclaimer": {
                                                        "text": "Not all accidents or other issues are reported to CARFAX. The number of owners is estimated. See the full CARFAX Report for additional information and glossary of terms. As of Apr 21, 2021.",
                                                        "iconUrl": "https://partnerstatic.carfax.com/img/disclaimer/disclaimer.png",
                                                        "grayIconUrl": "https://partnerstatic.carfax.com/img/disclaimer/disclaimer_blk.png"
                                                    }
                                                },
                                                dealerReport: {
                                                    carfaxLink: {
                                                        "url": "https://connect.carfax.com/dir?key=WIvldOcnULg26jdsfkl80wBAKXiss8wugOk4DUAzte-zr9XMW7ZAqUS1u7_VaJfTktU9_voHw9ukpmE-HVq6aeM-fxXV0NaOL16QSSZat0CpdVLGZmaKXrhrQs7d3f4-N4M9YtjC4zK7Oqm0HJRgNJdt_1abjY-FKlpBqd"
                                                    },
                                                    snapshotKey: "WIvldOcnULg26jdsfkl80wBAKXiss8wugOk4DUAzte-zr9XMW7ZAqUS1u7_VaJfTktU9_voHw9ukpmE-HVq6aeM-fxXV0NaOL16QSSZat0CpdVLGZmaKXrhrQs7d3f4-N4M9YtjC4zK7Oqm0HJRgNJdt_1abjY-FKlpBqd"
                                                },

                                            },
                                        },
                                        null,
                                        4
                                    )
                                )
                            ]}/>}/>
                    </p>

                    <p>
                        Note that all logos, icons, data and disclaimer verbiage must be included
                        in order to ensure a consistent and approved experience. Logos and icons
                        are provided in both a color and black format.
                    </p>

                    <hr/>
                    <section>
                        <h4 id={"dealer-snapshot-for-stickers"}>Dealer Snapshot for Stickers - Rep Based
                            Application</h4>
                        <p>
                            If you host an application that is used by representatives from your company to print
                            window stickers on behalf of dealers on the lot CARFAX Connect may still be used to add
                            Snapshot to the stickers. In this case, the dealer will not log in to CARFAX but instead
                            a dealer ID will be passed in the query to facilitate the report purchase and delivery of
                            Snapshot. This dealer ID corresponds to the dealer in your system and is shared via a
                            daily dealer list file sent to CARFAX. In most cases this recurring dealer file is
                            likely already sent to CARFAX for other product purposes but if you are a new partner
                            your CARFAX account manager will work with you to set this up.
                        </p>
                        <p>
                            Please use the following query to fetch the Snapshot data at the time of producing the
                            sticker in your application. Note the use of the dealerID in this query.
                        </p>
                    </section>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "GraphQL",
                            `query {
  dealerWindowSticker(vin: "1N4AL11DX6N393946", dealerId: "1504") 
}`
                        )
                    ]}/>
                    <p>
                        Sample Response:
                        <CollapsibleContent content={
                            <CodeSnippetTemplate codeSnippets={[
                                new CodeSnippet(
                                    CodeSnippetLanguages.JSON,
                                    "JSON",
                                    JSON.stringify(
                                        {
                                            "data": {
                                                "dealerWindowSticker": {
                                                    "items": [
                                                        {
                                                            "text": "Show Me the CARFAX Badge",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/valuebadge/showme.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/valuebadge/showme.png"
                                                        },
                                                        {
                                                            "text": "CARFAX 1-Owner",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/valuebadge/1own.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/valuebadge/1own_blk.png"
                                                        },
                                                        {
                                                            "text": "No accidents or damage reported to CARFAX",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_noAccident.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_noAccident_blk.png",
                                                            "iconKey": "NO_ACCIDENT"
                                                        },
                                                        {
                                                            "text": "CARFAX 1-Owner vehicle",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_owner1.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_owner1_blk.png",
                                                            "iconKey": "OWNER_1"
                                                        },
                                                        {
                                                            "text": "23 Service history records",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_service.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_service_blk.png",
                                                            "iconKey": "SERVICE"
                                                        },
                                                        {
                                                            "text": "Personal vehicle",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_personal.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_personal_blk.png",
                                                            "iconKey": "PERSONAL"
                                                        },
                                                        {
                                                            "text": "Last owned in Alabama",
                                                            "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_stateOwned.png",
                                                            "grayIconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_stateOwned_blk.png",
                                                            "iconKey": "STATE_OWNED"
                                                        }
                                                    ],
                                                    "disclaimer": {
                                                        "text": "Not all accidents or other issues are reported to CARFAX. The number of owners is estimated. See the full CARFAX Report for additional information and glossary of terms. As of Apr 29, 2021.",
                                                        "iconUrl": "https://partnerstatic.carfax.com/img/disclaimer/disclaimer.png",
                                                        "grayIconUrl": "https://partnerstatic.carfax.com/img/disclaimer/disclaimer_blk.png"
                                                    }
                                                }
                                            }
                                        },
                                        null,
                                        4
                                    )
                                )
                            ]}/>}
                        />
                    </p>
                    <p>
                        In cases where a Dealer ID is not mapped properly in the CARFAX system the following error
                        will be returned. Dealer IDs may be updated manually in cases such as this if needed by
                        contacting CARFAX Partner Help at PartnerHelp@carfax.com or calling 571-321-7413 option 1.
                        Details of what information is needed and how to make these requests will be provided by
                        your CARFAX account manager.
                    </p>
                    <p>
                        Error Response:
                        <CollapsibleContent content={

                            <CodeSnippetTemplate codeSnippets={[
                                new CodeSnippet(
                                    CodeSnippetLanguages.JSON,
                                    "JSON",
                                    JSON.stringify(
                                        {
                                            "errors": [
                                                {
                                                    "message": "Exception while fetching data (/dealerWindowSticker) : Account Status Invalid.",
                                                    "locations": [
                                                        {
                                                            "line": 2,
                                                            "column": 3
                                                        }
                                                    ],
                                                    "path": [
                                                        "dealerWindowSticker"
                                                    ],
                                                    "extensions": {
                                                        "displayableErrorMessage": "Your CARFAX account is no longer active. Please contact CARFAX for details.",
                                                        "requestId": "WUTAff_hdPTnLhARBul_-aU0lRA-A-YTz0mmmsAqwdicOCpKgg4ptw==",
                                                        "errorCode": "INVALID_ACCOUNT",
                                                        "vin": "1N4AL11DX6N393946",
                                                        "classification": "DataFetchingException"
                                                    }
                                                }
                                            ],
                                            "data": {
                                                "dealerWindowSticker": null
                                            }
                                        },
                                        null,
                                        4
                                    )
                                )
                            ]}/>}/>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"open-recall-flag"}>Open Recall Flag</h3>
                    <p>
                        As a supplement to the 4 Pillars data, CARFAX Connect also provides an indication of whether a
                        VIN has an Open Recall. This valuable data point may be displayed using the icon and text below
                        that is delivered in the Connect response:
                        <br/>
                        <span><img src={imgRecall} alt="Open Recall Flag" width="35"/> Open Recall</span>
                    </p>
                    <p>
                        Note that the Recall flag may be only be displayed on retail inventory in a dealer facing application
                        and is only available for CARFAX Advantage dealers in Enhanced partner applications.
                        The flag is only returned when the CARFAX Report has been run but as it is only available to
                        Advantage dealers Enhanced partners may use the <code>dealerReport</code> query to run the report and fetch this flag.
                        <br/><br/>
                        Sample Request:
                        <CodeSnippetTemplate codeSnippets={[new CodeSnippet(CodeSnippetLanguages.GRAPHQL, "GraphQL",
                            `query {
  dealerReport (vin: "1B3JZ69Z06V100028") {
    recall {
      hasOpenRecall
      iconUrl
      iconText
    }
  }
}`)]}/>
                        <br/>
                        Sample Response:
                        <CodeSnippetTemplate codeSnippets={[new CodeSnippet(CodeSnippetLanguages.JSON, "JSON",
                            `{
  "data": {
    "dealerReport": {
      "recall": {
        "hasOpenRecall": true,
        "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_recall.svg",
        "iconText": "Open Recall"
      }
    }
  }
}`)]}/>
                        <br/>
                        If there are no open recalls, you will receive the following response:
                        <CodeSnippetTemplate codeSnippets={[new CodeSnippet(CodeSnippetLanguages.JSON, "JSON",
                            `{
  "data": {
    "dealerReport": {
      "recall": {
        "hasOpenRecall": false,
        "iconUrl": null,
        "iconText": "No Open Recalls"
      }
    }
  }
}`)]}/>
                    </p>
                    <p>
                        If a query is attempted for a non-Advantage dealer using an Enhanced partner application,
                        Connect will return the following response:
                        <CodeSnippetTemplate codeSnippets={[new CodeSnippet(CodeSnippetLanguages.JSON, "JSON",
                            `{
  "data": {
    "dealerReport": {
      "recall": {
        "hasOpenRecall": false,
        "iconUrl": null,
        "iconText": null
      }
    }
  }
}`)]}/>
                    </p>
                    <p>
                        If a query is attempted for any dealer using a Basic partner
                        application, the following error will be returned:
                        <CodeSnippetTemplate codeSnippets={[new CodeSnippet(CodeSnippetLanguages.JSON, "JSON",
                            `{
  "errors": [
    {
      "message": "Validation error of type FieldUndefined: Field 'recall' in type 'DealerReport' is undefined @ 'dealerReport/recall'",
      "locations": [
        {
          "line": 3,
          "column": 5
        }
      ],
      "extensions": {
        "classification": "ValidationError"
      }
    }
  ],
  "data": null
}`)]}/>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"vehicle-information"}>Vehicle Information</h3>
                    <p>
                        In GraphQL, the data for the queries is returned in the same order that it was requested.
                        Although there may be Use Cases where the final state of the data is not in the same order.
                        In that case, there will need to be some sort of explicit mapping for the requested data with
                        its response.
                        CARFAX Connect supports the <code>Vehicle</code> Type which can be used to get back basic
                        Vehicle information,
                        such as the <code>vin</code> to map the requested data to its response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `query {
    dealerReport(vin: "VIN123") {
        carfaxLink {
            url
        }
   
        vehicle {
            vin
        }
    }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Alternatively, <Link to={`${Constants.SEND_QUERIES_PAGE_URL}#graphql-aliases`}>GraphQL
                        Aliases</Link> can
                        be used to achieve this mapping.
                    </p>
                    <p>
                        Please note that the VIN is also returned in cases when an error occurs to aid in diagnosing the
                        given issue.
                        See <Link to={`${Constants.ERROR_HANDLING_PAGE_URL}`}>Error Handling</Link> for more information
                        and
                        examples of how the VIN is returned with errors.
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id="connect-caching">CARFAX Connect Caching Guidelines</h3>
                    <p>
                        <p>
                            We recommend to simply use one user per dealer to fetch the 4 Pillar data, Dealer Instant
                            Report (DIR) link and Snapshot key. The data may be cached in your local DB and then be
                            mapped back to all other users in your system associated with the given dealership. Store
                            these elements for preferably 24 hours before refreshing but they may reside in cache for up
                            to seven days corresponding to the expiration date of the Dealer Report link. Details are
                            below for various use cases:
                        </p>

                        <h5 id={"first-login"}>User logs in the first time via Connect</h5>
                        <p>
                            Note that this is specific to the first time a dealer’s first user logs in. So if a dealer
                            in your system has five users you would follow this step when the first of the five users
                            logs in.
                        </p>

                        <ol>
                            <li>
                                Use the access token to query Connect for the list of ALL VINs associated with this
                                first logged in user at the dealership (typically the list of retail units) and cache
                                the 4 Pillar data, DIR links and Snapshot keys.
                            </li>
                            <li>
                                For any of the subsequent users (the other four users in the example) at the same
                                dealership that log in after the first user most of the VINs will already be in the
                                cache so simply use the 4 Pillar data, DIR links and Snapshot key from the local DB
                                cache.
                            </li>
                            <li>
                                For any VINs not in cache (e.g. the next user has new inventory listed) query Connect to
                                get the 4 Pillar data, DIR link and Snapshot key. Cache to the local DB and display it.
                            </li>
                        </ol>
                        <p>
                            These Connect queries may be done through asynchronous requests. 100 requests/call are
                            supported and will not affect page load latency. Please see the <Link
                            to={`${Constants.SEND_QUERIES_PAGE_URL}#batch-requests`}>Batch Requests</Link> section for
                            details.
                        </p>
                        <p>
                            Note that non-Advantage dealers will only receive 2 Pillar data (Accident and # of Owners)
                            on reports already run.
                        </p>

                        <h5>Vehicle added to inventory</h5>
                        <ol>
                            <li>
                                Query Connect real-time to get the 4 Pillar data, DIR link and Snapshot key for an
                                Advantage dealer or when a Pay Per VIN/Advantage Limited dealer clicks the “View CARFAX
                                Report” link.
                            </li>
                            <li>
                                Display the response to the user immediately and add this data to the local DB cache for
                                use across other users at the same dealer.
                            </li>
                        </ol>

                        <h5>User logs out of CARFAX via your Settings screen</h5>
                        <ol>
                            <li>
                                Do not continue to render the cached 4 Pillar data, DIR links or Snapshot for any
                                vehicles but keep the “View CARFAX Report” links to enable the user to easily log back
                                in upon clicking.
                            </li>
                            <li>
                                The 4 Pillar data, the DIR links and Snapshot key can be kept in the local DB cache to
                                be used should the user log back in or to render for other users at the same dealership.
                                Again, store these elements for preferably 24 hours but up to seven days corresponding
                                to the expiration date of the DIR link.
                            </li>
                        </ol>
                        <p>
                            Note: Please see the Log Out section under the <Link
                            to={`${Constants.AUTHENTICATION_PAGE_URL}#web-application-flow`}>Web Application
                            Flow</Link> for details on how to log out a user.
                        </p>

                        <h5>Refresh token expires for a given user</h5>
                        <ol>
                            <li>
                                The Connect refresh token expires after 30 days and may only be used once to fetch an
                                access token.
                                After a 30-day inactivity period, any attempts to call Connect will result in a
                                401 Unauthorized error referring to the token being expired.
                            </li>
                            <li>
                                Continue to render 4 Pillar data, DIR links and Snapshot via the key from the local DB
                                cache which would store these elements for preferably 24 hours but can reside in cache
                                for up to seven days corresponding to the expiration date of the DIR link. Goal here is
                                to not cause the CARFAX data to abruptly disappear for users who are not proactively
                                logging out.
                            </li>
                            <li>
                                If a new vehicle is added to inventory the 4 Pillar data, DIR link and Snapshot will not
                                be available immediately but may render if another user at the dealership has viewed the
                                same car as it will pull the data and load it in to the cache to be shared across users.
                            </li>
                            <li>
                                Continue to post the “View CARFAX Report” links. When the link is clicked Connect will
                                return an error indicating the refresh token has expired. The user should then be
                                redirected to the Log In screen.
                            </li>
                        </ol>

                        <h5>User logs in again (for any user at a dealer)</h5>
                        <ul>
                            <li>
                                For those VINs where the 4 Pillar data, DIR links and Snapshot keys still remain in the
                                local DB cache render the CARFAX data to the user.
                            </li>
                            <li>
                                You should only query Connect directly for VINs that are not already in your cache.
                            </li>
                            <li>
                                Once retrieved the data should be cached and displayed to the user.
                            </li>
                            <li>
                                The recommendation is to use asynchronous calls for the fetching the data.
                            </li>
                        </ul>

                        <h5>Other key timing rules for caching to ensure CARFAX data remains in sync with the vehicle
                            history report:</h5>
                        <ul>
                            <li>
                                When the “View CARFAX Report” link is clicked, a refresh of the locally cached data (4
                                Pillar data, DIR links and Snapshot keys) for that VIN should be fetched
                            </li>
                            <li>
                                When the data cache TTL date/time has passed then the respective CARFAX data should not
                                be displayed and should be removed from cache, or it should be re-queried overnight /
                                asynchronously to keep the cached data current
                            </li>
                            <li>
                                If an “Invalid Account Error" is returned by Connect, indicating the dealer account is
                                no longer valid, then all the CARFAX data for the dealership should be removed from the
                                cache. None of the users associated with the dealership should have the 4 Pillar data,
                                DIR links or Snapshot rendered.
                            </li>
                        </ul>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id="carfax-branding">CARFAX Branding</h3>
                    <p>
                        All references to CARFAX throughout partner applications should always be in all caps.
                    </p>
                    <p>
                        To ensure a consistent and clear message for dealers across partner applications please use the
                        following copy on the Settings/Admin screen where users may log in or sign out. Note the use of
                        “log in” as a verb versus “login” as a noun.
                        <br/>
                        <img src={LogInMock} width="381px" height="180px" alt="Mockup of partner app log in link"/>
                        <br/>
                        The generic screenshots below show how CARFAX may be integrated on a list level and vehicle
                        detail page in a dealer facing application. Items of note:
                    </p>
                    <ul>
                        <li>The link to the dealer report should state “View CARFAX Report” or simply “CARFAX
                            Report” if space is limited.
                        </li>
                        <li>The 2 or 4 Pillar data should be featured using the icon image URLs Connect returns in
                            the API response.
                            Use of this data on a listings page also affords the opportunity to add a sort and
                            filter option as shown on the
                            left rail in the mock.
                        </li>
                        <li>
                            Dealer Snapshot may be featured as a hover-over on a list level rendering just to the
                            left and above the
                            “View CARFAX Report” link. Snapshot may also be embedded on a detail page.
                        </li>
                        <li>
                            On a detail page the CARFAX logo should be featured with “View Report” text.
                            If space allows for the 4 Pillar data please use the icon image URLs Connect returns in
                            the API response.
                            In the example below we also show the option to post a mouse-over on each icon to
                            display the underlying copy
                            for the icon which is also returned in the API response. The appropriate CARFAX logo may
                            be downloaded here:
                            <br/><br/>
                            <a href={imgLogoWhite} target={"_blank"} rel={"noopener noreferrer"}>CARFAX Logo for use
                                on a black background</a>
                            <br/><br/>
                            <a href={imgLogoBlack} target={"_blank"} rel={"noopener noreferrer"}>CARFAX Logo for use
                                on a white background</a>
                        </li>
                    </ul>
                    <Image src={imgDemoMock} className={"img-fluid"}/>
                    <Image src={imgPillarHover} fluid className={"img-fluid"}/>
                </section>
                <hr/>
                <section>
                    <h3 id="carfax-dealer-faqs">Customer Support FAQs</h3>
                    <p>
                        To aid your customer care team in addressing questions from dealers after launch please
                        download our <a href={PartnerSupportPDF} download="CARFAX Partner Support FAQs.pdf">
                        Customer Support FAQs.</a>
                    </p>

                </section>

                {/*Stoplight Documentation*/}

                <hr/>
                <section>
                    <h1 id={"stoplight-header"}>Stoplight</h1>
                    <p>
                        <strong>*Please note that Stoplight is not assigned by default to a Dealer Partner. Your CARFAX
                            Account Manager will work with you to determine if this is a suitable product for your
                            specific use case.</strong>
                    </p>
                    <h3 id={"stoplight-overview"}>Overview</h3>
                    <p>
                        CARFAX Stoplight is a product delivered via CARFAX Connect that allows for a VIN to be checked
                        against a set of predefined vehicle history criteria to determine if any of the events are
                        present. A Red Light and Yellow Light set of criteria may be independently configured to allow
                        partners to first check for major events and then subsequently moderate events. This enables the
                        Stoplight product to be used in multiple ways such as by dealers or OEMs screening consumer
                        vehicles in a cash offer tool, by dealers flagging risky acquisitions to avoid from auctions, or
                        dealers getting daily updates on possible vehicle history changes on their retail inventory.
                        Stoplight will return a “fail” response when one or more of the defined events are present in
                        the history of the VIN submitted or a “pass” response when no events are present. The specific
                        underlying data points that failed or passed are not returned in the response.
                    </p>
                    <p>
                        Below is an example of a Red Light and Yellow Light configuration which may be used as a
                        baseline of data sets from which to choose for your specific needs. Data may be shifted
                        between the two sets or removed entirely. Note that Stoplight
                        may also be configured to only use a single Red Light set of criteria depending upon your use case.
                    </p>
                    <Table striped bordered size={"sm"} className={"stoplight-table-center"}>
                        <thead>
                        <tr>
                            <th></th>
                            <th>Red Light = Major Problems</th>
                            <th>Yellow Light = Moderate Problems</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                Branded Titles
                            </td>
                            <td>
                                Exceeds Mechanical Limits<br/>
                                Fire<br/>
                                Flood Damage<br/>
                                Hail Damage<br/>
                                Junk<br/>
                                Lemon/Buyback<br/>
                                Not Actual Mileage<br/>
                                Rebuilt/Reconstructed<br/>
                                Salvage
                            </td>
                            <td>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Other Damage Events
                            </td>
                            <td>
                                Fire<br/>
                                Flood/Water<br/>
                                Structural<br/>
                                Total Loss<br/>
                                Vandalism
                            </td>
                            <td>
                                Accident Reported<br/>
                                Airbag Deployed<br/>
                                Damage Reported
                            </td>
                        </tr>

                        <tr>
                            <td>
                                Damage Severity
                            </td>
                            <td>
                                Moderate to Severe<br/>
                                Severe
                            </td>
                            <td>
                                Very Minor<br/>
                                Minor<br/>
                                Minor to Moderate<br/>
                                Moderate
                            </td>
                        </tr>

                        <tr>
                            <td>
                                Use Type
                            </td>
                            <td>
                                Police<br/>
                                Taxi
                            </td>
                            <td>
                                Government<br/>
                                Rental
                            </td>
                        </tr>
                        <tr>
                            <td>Other</td>
                            <td>
                                Currently Stolen<br/>
                                Odometer Problem/Rollback<br/>
                                Reacquired by Manufacturer
                            </td>
                            <td></td>
                        </tr>
                        </tbody>

                    </Table>
                </section>
                <hr/>
                <section>
                    <h3 id={"stoplight-prerequisites"}>Prerequisites</h3>
                    <p>
                        Before you can authenticate and start running queries on CARFAX Connect, you must be configured
                        by Carfax for the Stoplight service and have
                        a <strong>Client
                        Credentials</strong> Application set up in the Partner Portal. You can choose to use the one we
                        provided
                        (App Type - Client Credentials), or use one that you create.
                    </p>
                    <p className={"text-center"}>
                        <img
                            src={PartnerPortalApplications}
                            width="647px"
                            alt="Partner Portal: Applications Screen"
                        />
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"stoplight-authentication"}>Authentication</h3>
                    <p>
                        To get started a lead developer will receive an invitation to the Connect Partner Portal as
                        noted on the <Link to={Constants.AUTHENTICATION_PAGE_URL}>Authentication</Link> page.
                    </p>
                    <p>
                        Once you have access to the Partner Portal, create a Client Credentials application. With the
                        Client Credentials application built, you next need to authenticate to receive an access token
                        (JWT). This token will allow you to make requests to CARFAX Connect in the form of GraphQL
                        queries to receive Stoplight information for a given VIN.
                    </p>
                    <p>
                        <strong>IMPORTANT</strong>: An access token once obtained is valid for 24 hours and should be reused until it expires.
                        Please do not fetch a new access token with each request. If coded properly we would expect to see one refresh per day if calling from a single machine or perhaps as many as 10 if using distributed machines to call Connect.
                        The expiration is identified via expires_in which is in seconds. Be sure to obtain a fresh token sufficiently far in advance to allow for network delays and clock skew.
                    </p>
                    <p>
                        Refer to this documentation page for more information on how to establish the Client Credentials
                        application and authenticate -
                        <Link to={Constants.AUTHENTICATION_PAGE_URL + "#client-credentials-flow"}>Client Credentials
                            Authentication</Link>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"stoplight-sending-request"}>Sending A Request</h3>
                    <p>
                        A request may be made with a VIN to check for any Red Light major problems and Yellow Light
                        moderate problems simultaneously or independently. Stoplight may also be configured to only use
                        a single Red Light set of criteria depending upon the use case.
                    </p>
                    <p>
                        Once you have successfully authenticated and have an access token (JWT), you may make a request
                        to receive Stop Light information for a given VIN. Note that the examples below demonstrate the
                        option of sending a single VIN with a dual request for Red Light and Yellow Light but you also
                        have the option of querying Red Light or Yellow Light independently.
                    </p>
                    <p>
                        The following is the GraphQL Schema that you may use to make the request to CARFAX Connect:
                    </p>

                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "GraphQL",
                            `query {
    stopLight(vin: "VIN123") {
         redLight {
          pass
        }
        yellowLight {
          pass
        }
        vehicle {
          vin
        }
      }
}`
                        )
                    ]}/>
                    <p>
                        You may use the following cURL to send an HTTP request to receive Stoplight information for a
                        given VIN:
                    </p>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(CodeSnippetLanguages.MARKUP, 'cURL',
                            `curl --request POST \\
--url https://connect.carfax.com/v1/graphql \\
--header 'Authorization: Bearer <access_token>' \\
--header 'Content-Type: application/json' \\
--data '{"query":"query {\\n stopLight(vin: \\"VIN123\\") {\\n redLight {\\n pass\\n }\\n yellowLight {\\n pass\\n }\\n }\\n}"}'`)
                    ]}/>
                    <p>
                        The following is a sample response in JSON:
                    </p>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "JSON",
                            `{
    "data": {
      "stopLight": {
        "redLight": {
          "pass": true
        },
        "yellowLight": {
          "pass": false
        }
        "vehicle": {
          "vin": "VIN123"
        }
      }
    }
}`
                        )
                    ]}/>
                    <p>
                        The expected use case is for a single VIN to be queried but note that Connect supports batch
                        requests as outlined in the <Link to={`${Constants.SEND_QUERIES_PAGE_URL}#batch-requests`}>Batch
                        Requests</Link> page. If using batch requests, note that 25 queries in a single batch request is
                        the maximum for Stoplight to ensure optimal performance.
                    </p>
                </section>
                <hr/>
                <section>
                    <h1 id={"chbv-header"}>CARFAX History Based Value</h1>
                    <p>
                        <strong>*Please note that CARFAX History-Based Value is not assigned by default and is only available for Advantage dealers. Your CARFAX Account Manager
                            will work with you to determine if this is a suitable product for your specific use case and which integration method is applicable.</strong>
                    </p>
                    <h3 id={"chbv-overview"}>Overview</h3>
                    <p>Every car has a unique history, and therefore a unique value. CARFAX now has a product, the CARFAX History-Based Value, which
                        provides VIN-specific used car values in the marketplace. By having access to the CARFAX History-Based Value dealers and consumers
                        are able to make better buying and selling decisions.</p>
                    <h3>Use CARFAX Connect to Feature CARFAX History-Based Value</h3>
                    <p>
                        CARFAX Connect enables dealer facing integration partners to display CARFAX History-Based Value in pricing or trade evaluation
                        tools.  There are two options available to integrate CARFAX History-Based Value:
                    </p>
                    <ul>
                        <li>
                            <strong>Dealer Authenticated</strong> - This option will be used in most cases and is where dealer users must first link their account in the partner
                            application to their CARFAX account. Connect uses an <Link
                            to={`${Constants.AUTHENTICATION_PAGE_URL}#authorization-code-flow`}>OAuth 2
                            authorization code flow</Link> to let users authorize the partner to access CARFAX
                            Connect on their behalf.  When Connect processes a request it identifies the dealer based on the access token sent in the request
                            header. Once you have acquired a token via CARFAX Connect, you can make requests to fetch a vehicle’s value, fetch an updated value based
                            on user input, or save changes.  Zip code is optional for all requests. If you do not provide one, the zip code associated to the username
                            in the access token will be used.
                        </li>
                        <li>
                            <strong>Partner Authenticated</strong> - This option is reserved for rare cases where a partner themselves fetches the CARFAX History-Based Value and no
                            dealer login is required.  All queries and responses noted below are the same but in this case Connect uses a <Link
                            to={`${Constants.AUTHENTICATION_PAGE_URL}#client-credentials-flow`}>Client Credentials flow</Link>.  Zip
                            code is optional for all requests. If you do not provide one, the zip code associated to the partner in the access token will be used.
                        </li>
                    </ul>
                </section>
                <hr/>
                <section>
                    <h3 id={"chbv-fetch"}>Fetch a CARFAX Value</h3>
                    <p>The following is the GraphQL Schema that you may use to make the request to CARFAX Connect:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "JSON",
                                `query($chbvInput: ChbvFetchInput) {
  historyBasedValueFetch(chbvInput: $chbvInput) {
    fairConditionValues {
      wholesale
      retail
      certified
    }
    goodConditionValues {
      wholesale
      retail
      certified
    }
    excellentConditionValues {
      wholesale
      retail
      certified
    }
    trims {
      name
      selected
    }
    options {
      name
      selected
    }
    arrows{
     up {
       direction
       iconUrl
       text
     }
     down {
       direction
       iconUrl
       text
     }
    }
  }
}`
                            )
                        ]}/></p>
                    <p>Variables:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "chbvInput": {
    "zipCode": "12345",
    "vin": "JN8AS1MW8BM734369",
    "odometer": "12345",
    "mobile": true
  }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        The fields are defined below from top to bottom:
                        <ul>
                            <li>
                                <strong>zipCode:</strong> the zip code that you are requesting a value for. This is an optional field. If
                                not included, we use the zip code associated with the dealer's account.
                            </li>
                            <li>
                                <strong>vin:</strong> the VIN of the vehicle for which you are requesting a value.
                            </li>
                            <li>
                                <strong>odometer:</strong> the odometer of the vehicle for which you are requesting a value. This is an
                                optional field. If not included, CARFAX will use the CARFAX Estimated Current Mileage.
                            </li>
                            <li>
                                <strong>mobile:</strong> a Boolean value representing whether or not the request is being made for a
                                mobile web or application user.
                            </li>
                        </ul>
                    </p>
                    <p>
                        Example of a successful response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "data": {
    "historyBasedValueFetch": {
      "fairConditionValues": {
        "wholesale": 6440,
        "retail": 11550,
        "certified": 11550
      },
      "goodConditionValues": {
        "wholesale": 7230,
        "retail": 12960,
        "certified": 12960
      },
      "excellentConditionValues": {
        "wholesale": 7710,
        "retail": 13820,
        "certified": 13820
      },
      "trims": [
        {
          "name": "OVERLAND",
          "selected": true
        }
      ],
      "options": []

      "arrows": {
        "up": [
            {
                "direction": "https://media.carfax.com/img/vhr/oneprice/icon-up-med.png",
                "iconUrl": "https://media.carfax.com/img/vhr/ico_noAccident.gif",
                "text": "No Accidents Reported"
            },
            {
                "direction": "https://media.carfax.com/img/vhr/oneprice/icon-up-med.png",
                "iconUrl": "https://media.carfax.com/img/vhr/ico_service.gif",
                "text": "Service History"
            },
            {
                "direction": "https://media.carfax.com/img/vhr/oneprice/icon-up-med.png",
                "iconUrl": "https://media.carfax.com/img/vhr/ico_personal.gif",
                "text": "Personal Vehicle"
            },
            {
                "direction": "https://media.carfax.com/img/vhr/oneprice/icon-up-med.png",
                "iconUrl": "https://media.carfax.com/img/vhr/ico_cpo.gif",
                "text": "Prior Certified Pre-Owned"
            }
         ],
        "down": [
        {
                "direction": "https://media.carfax.com/img/vhr/oneprice/icon-down-med.png",
                "iconUrl": "https://media.carfax.com/img/vhr/ico_information.gif",
                "text": "Minor Damage"
            }]
        }
      }
    }
  }`
                            )
                        ]}/>
                    </p>
                    <p>
                        Field descriptions:
                        <ul>
                            <li>
                                <strong>trims:</strong> lists all the trims that CARFAX believes are valid for the given VIN.
                                For each request, the response assumes a trim.
                            </li>
                            <li>
                                <strong>conditions:</strong> represents the three conditions that CARFAX uses to value
                                vehicles. CARFAX will assume a condition in the response; the condition “selected” will
                                be set to true.
                            </li>
                            <li>
                                <strong>colors:</strong> lists the possible colors for the vehicle with the one CARFAX assumes
                                for the vehicle having a “selected” value of true.
                            </li>
                            <li>
                                <strong>options:</strong> lists the options that impact the vehicle’s value with the ones
                                CARFAX assumes for the vehicle having a “selected” value of true.
                            </li>
                            <li>
                                <strong>arrows:</strong> of the response will only appear if the user associated with the
                                Access Token supplied in the request belongs to a CARFAX Advantage dealer.
                            </li>
                        </ul>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"chbv-update"}>Update a CARFAX Value</h3>
                    <p>
                        If a user wants to change any input (zip code, odometer, condition, trim, colors, or options) in
                        order to update a value, please make a request to CARFAX Connect as noted below:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "JSON",
                                `query($chbvInput: ChbvInput) {
  historyBasedValueUpdate(chbvInput: $chbvInput) {
    fairConditionValues {
      wholesale
      retail
      certified
    }
    goodConditionValues {
      wholesale
      retail
      certified
    }
    excellentConditionValues {
      wholesale
      retail
      certified
    }
  }
}`
                            )
                        ]}/>
                        <p>Variables:</p>
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "chbvInput":{
    "zipCode":"65201",
    "vin":"1G6AN1RY0G0100696",
    "odometer":"43318",
    "mobile":true,
    "condition":"excellent",
    "trim":{
      "name":"BASE",
      "selected":true
    },
    "colors":[
      {
        "name":"blue",
        "selected":true
      },
      {
        "name":"red",
        "selected":false
      }
    ],
    "options":[
      {
        "name":"Navigation System",
        "selected":true
      },
      {
        "name":"Premium Wheels",
        "selected":false
      }
    ]
  }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Note that it is recommended you submit all trim, colors and options noted whether “true” or
                        “false” when trying to update a value, but you may submit only those listed as “true” if you
                        wish to streamlines the request. It is also recommended that you test the requests thoroughly if
                        opting to only submit those as “true”.
                    </p>
                    <p>
                        This request uses much of the information sent in the original response. The response to the
                        update request (see below) will be the new values based on the selected changes to zip code,
                        odometer, condition, trim, colors, and/or options:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "data": {
    "historyBasedValueUpdate": {
      "fairConditionValues": {
        "wholesale": 28300,
        "retail": 36430,
        "certified": 36430
      },
      "goodConditionValues": {
        "wholesale": 29410,
        "retail": 37860,
        "certified": 37860
      },
      "excellentConditionValues": {
        "wholesale": 30160,
        "retail": 38830,
        "certified": 38830
      }
    }
  }
}`
                            )
                        ]}/>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"chbv-save"}>Save Changes</h3>
                    <p>
                        The request for saving user selected options, trim, odometer reading, and condition information
                        uses the same format as the Update request. However, instead of returning a price like the
                        update response, it returns a response indicating the success or failure of the save request.
                        Any future fetch requests for a given VIN will assume the saved information instead of CARFAX’s
                        assumed information. Any future update requests for a given VIN will assume the request input.
                        The exceptions are saved odometer readings and condition fields which will expire after 90 days.
                    </p>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "JSON",
                            `mutation($chbvInput: ChbvInput) {
  historyBasedValueSave(chbvInput: $chbvInput) {
    displayableMessage
  }
}`
                        )
                    ]}/>
                    <p>Variables:

                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "chbvInput":{
    "zipCode":"65201",
    "vin":"1G6AN1RY0G0100696",
    "odometer":"43318",
    "mobile":true,
    "condition":"excellent",
    "trim":{
      "name":"BASE",
      "selected":true
    },
    "colors":[
      {
        "name":"blue",
        "selected":true
      },
      {
        "name":"red",
        "selected":false
      }
    ],
    "options":[
      {
        "name":"Navigation System",
        "selected":true
      },
      {
        "name":"Premium Wheels",
        "selected":false
      }
    ]
  }
}`
                            )
                        ]}/></p>
                    <p>
                        Example of a successful response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "data": {
    "historyBasedValueSave": {
      "displayableMessage": "Save Successful"
    }
  }
}`
                            )
                        ]}/>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"chbv-errors"}>Errors</h3>
                    <p>
                        Below are error scenarios that are specific to CARFAX History-Based Value and the corresponding
                        response provided by Connect which may be displayed to users in your application. Note that
                        other error cases common to Connect may be found on the&nbsp;<Link
                        to={`${Constants.ERROR_HANDLING_PAGE_URL}`}>error handling page</Link>.
                    </p>
                    <p>
                        Non-Advantage dealer: CARFAX History-Based Value is only available for advantage dealers.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "errors":[
    {
      "message": "Exception while fetching data (/historyBasedValueUpdate) : CHBV is only available for advantage dealers.",
      "locations": [
        {
          "line": 2,
          "column": 5
        }
      ],
      "path": [
        "location"
      ],
      "extensions": {
        "displayableErrorMessage":"Feature only available for CARFAX Advantage dealers.  Please contact your CARFAX Representative to upgrade your account.",      
        "errorTracingId": "69a520e2-cdd3-4d62-83ec-d0d0634e0ee7",
        "requestId": "-XKeqfTSC9z1zheLmrlX9uq0ANoxdp9WkUf53EVxJzl-BF-Ko_ahMw==",
        "errorCode": "CHBV_NOT_ADVANTAGE",
        "vin": "VIN123",
        "classification": "DataFetchingException"
      }
    }
  ]
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Zip Code must be numeric and 5 characters long: The zip code provided is invalid or the
                        username associated with the access token does not have a valid zip code associated with it.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "errors":[
    {
      "message": "Exception while fetching data (/historyBasedValueUpdate) : The provided zipCode is not valid.",
      "locations": [
        {
          "line": 2,
          "column": 5
        }
      ],
      "path": [
        "location"
      ],
      "extensions": {
        "displayableErrorMessage":"Zip code must be numeric and 5 characters long.",      
        "errorTracingId": "69a520e2-cdd3-4d62-83ec-d0d0634e0ee7",
        "requestId": "-XKeqfTSC9z1zheLmrlX9uq0ANoxdp9WkUf53EVxJzl-BF-Ko_ahMw==",
        "errorCode": "CHBV_INVALID_ZIP",
        "vin": "VIN123",
        "classification": "DataFetchingException"
      }
    }
  ]
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Model Year 1999 or Older: CARFAX cannot price vehicles before model year 2000.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "errors":[
    {
      "message":"Exception while fetching data (/historyBasedValueUpdate) : Model Year 1999 or older.",
      "locations":[
        {
          "line":2,
          "column":5
        }
      ],
      "path":[
        "location"
      ],
      "extensions":{
        "displayableErrorMessage":"CARFAX only provides values for model years 2000 or newer.",
        "errorTracingId":"69a520e2-cdd3-4d62-83ec-d0d0634e0ee7",
        "requestId":"-XKeqfTSC9z1zheLmrlX9uq0ANoxdp9WkUf53EVxJzl-BF-Ko_ahMw==",
        "errorCode":"CHBV_YEAR_1999_OR_OLDER",
        "vin":"VIN123",
        "classification":"DataFetchingException"
      }
    }
  ]
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Vehicle Not In US: CARFAX does not currently price vehicles outside of the US.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "errors":[
    {
      "message":"Exception while fetching data (/historyBasedValueUpdate) : Vehicle Not in US.",
      "locations":[
        {
          "line":2,
          "column":5
        }
      ],
      "path":[
        "location"
      ],
      "extensions":{
        "displayableErrorMessage":"CARFAX only provides values on vehicles in the U.S.",
        "errorTracingId":"69a520e2-cdd3-4d62-83ec-d0d0634e0ee7",
        "requestId":"-XKeqfTSC9z1zheLmrlX9uq0ANoxdp9WkUf53EVxJzl-BF-Ko_ahMw==",
        "errorCode":"CHBV_VEHICLE_NOT_IN_US",
        "vin":"VIN123",
        "classification":"DataFetchingException"
      }
    }
  ]
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Insufficient Data Available: CARFAX cannot price this vehicle based on currently available data.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "errors":[
    {
      "message":"Exception while fetching data (/historyBasedValueUpdate) : Insufficient Data Available.",
      "locations":[
        {
          "line":2,
          "column":5
        }
      ],
      "path":[
        "location"
      ],
      "extensions":{
        "displayableErrorMessage":"CARFAX cannot provide a value due to insufficient data.",
        "errorTracingId":"69a520e2-cdd3-4d62-83ec-d0d0634e0ee7",
        "requestId":"-XKeqfTSC9z1zheLmrlX9uq0ANoxdp9WkUf53EVxJzl-BF-Ko_ahMw==",
        "errorCode":"CHBV_INSUFFICIENT_DATA",
        "vin":"VIN123",
        "classification":"DataFetchingException"
      }
    }
  ]
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Suspicious Odometer: There is a discrepancy between the provided odometer reading and the saved odometer reading.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "errors":[
    {
      "message":"Exception while fetching data (/historyBasedValueUpdate) : There is an odometer discrepancy.",
      "locations":[
        {
          "line":2,
          "column":5
        }
      ],
      "path":[
        "location"
      ],
      "extensions":{
        "displayableErrorMessage":"There is a discrepancy between the provided odometer reading and the saved odometer reading.",
        "errorTracingId":"69a520e2-cdd3-4d62-83ec-d0d0634e0ee7",
        "requestId":"-XKeqfTSC9z1zheLmrlX9uq0ANoxdp9WkUf53EVxJzl-BF-Ko_ahMw==",
        "errorCode":"CHBV_ODO_SUS",
        "vin":"VIN123",
        "classification":"DataFetchingException"
      }
    }
  ]
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        CARFAX History-Based Value not available: CARFAX History-Based Value has not been configured for this partner.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "errors":[
    {
      "message":"Exception while fetching data (/historyBasedValueUpdate) : CHBV is not configured for this partner.",
      "locations":[
        {
          "line":2,
          "column":5
        }
      ],
      "path":[
        "location"
      ],
      "extensions":{
        "displayableErrorMessage":"CARFAX History-Based Value has not been configured for this partner.",
        "errorTracingId":"69a520e2-cdd3-4d62-83ec-d0d0634e0ee7",
        "requestId":"-XKeqfTSC9z1zheLmrlX9uq0ANoxdp9WkUf53EVxJzl-BF-Ko_ahMw==",
        "errorCode":"CHBV_NOT_CONFIGURED",
        "vin":"VIN123",
        "classification":"DataFetchingException"
      }
    }
  ]
}`
                            )
                        ]}/>
                    </p>
                    <h4>Save-Specific Errors</h4>
                    <p>
                        Save Failed – Invalid CARFAX Credentials: The username associated with the access token is not
                        valid.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "errors": [
    {
      "message": "Exception while fetching data (/historyBasedValueSave) : Save failed",
      "locations": [
        {
          "line": 2,
          "column": 5
        }
      ],
      "path": [
        "historyBasedValueSave"
      ],
      "extensions": {
        "displayableErrorMessage": "Save Failed - Invalid CARFAX Credentials",
        "requestId": "52ab8a85-d2fd-469f-bb35-de71be82a13c",
        "errorCode": "CHBV_SAVE_FAILURE",
        "vin": "ZFF81BFA2H0220491",
        "classification": "DataFetchingException"
      }
    }
  ],
  "data": {
    "historyBasedValueSave": null
  }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Save Failed: The save failed because of an internal systems error.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                `{
  "errors": [
    {
      "message": "Exception while fetching data (/historyBasedValueSave) : Save failed",
      "locations": [
        {
          "line": 2,
          "column": 5
        }
      ],
      "path": [
        "historyBasedValueSave"
      ],
      "extensions": {
        "displayableErrorMessage": "Save Failed",
        "requestId": "52ab8a85-d2fd-469f-bb35-de71be82a13c",
        "errorCode": "CHBV_SAVE_FAILURE",
        "vin": "ZFF81BFA2H0220491",
        "classification": "DataFetchingException"
      }
    }
  ],
  "data": {
    "historyBasedValueSave": null
  }
}`
                            )
                        ]}/>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"chbv-style"}>Style Guide</h3>
                    <p>
                        CARFAX must approve the display of all integration. Please integrate CARFAX History-Based Value
                        using this style guide.
                    </p>
                    <h4>Type of Value Display</h4>
                    <p>You must label each type of sale as follows:
                        <ul>
                            <li>
                                Retail value should display as CARFAX Retail Value
                            </li>
                            <li>
                                Certified value should display as CARFAX Certified Value
                            </li>
                            <li>
                                Wholesale value should display as CARFAX Wholesale Value
                            </li>
                        </ul>
                    </p>

                    <h4>History Event Arrow Display</h4>
                    <p>
                        Service will return up to a maximum of 4 arrows
                        <ul>
                            <li>
                                Display UP arrows first and in the order the service returns.
                            </li>
                            <li>
                                Display DOWN arrows second and in the order the service returns.
                            </li>
                        </ul>
                    </p>
                    <p>
                        Use the text and image URLs returned in the service. These could change over time which ensures
                        the your application remains in sync with CARFAX.
                    </p>
                    <p>
                        Use the following Up and Down arrows:
                        <ul>
                            <li>
                                Up: <a target={"_blank"}
                                       rel="noopener noreferrer"
                                       href={"https://media.carfax.com/img/vhr/oneprice/icon-up-med.png"}>https://media.carfax.com/img/vhr/oneprice/icon-up-med.png</a>
                            </li>
                            <li>
                                Down: <a target={"_blank"}
                                         rel="noopener noreferrer"
                                         href={"https://media.carfax.com/img/vhr/oneprice/icon-down-med.png"}>https://media.carfax.com/img/vhr/oneprice/icon-down-med.png</a>
                            </li>
                        </ul>
                    </p>
                    <p>
                        Example of how CARFAX expects history event arrows to be displayed:
                        <br/>
                        <Image src={chbvHistoryArrows} className={"img-fluid"}/>
                    </p>
                    <p>
                        Glossary of all possible CARFAX History-Based Value arrows:
                    </p>
                    <Table striped bordered size={"sm"} className={"chbv-table"}>
                        <thead>
                        <tr>
                            <th>Text</th>
                            <th>Icon</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                No Accidents Reported
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_noAccident.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                    1-Owner Vehicle
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_owner1.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Regular Oil Changes
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_wellMaintained.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Service History
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_service.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Personal Vehicle
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_personal.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Prior CPO Vehicle
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_cpo.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Stolen Vehicle
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Salvage Brand
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Junk Brand
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Rebuilt Brand
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Fire Brand
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_magnifyingGlass.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Flood Brand
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_magnifyingGlass.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Hail Brand
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_magnifyingGlass.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Reconstructed Brand
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Dismantled Brand
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Damage Brand
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Vehicle Scrapped
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Crash Test Vehicle
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Total Loss
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Severe Damage
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Salvage Auction
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Vehicle at Recycler
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Buyback / Lemon
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Structural Damage
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Not Actual Mileage
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Exceeds Mechanical Limits
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Odometer Problem
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Verified Odometer Rollback
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_rollback.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Vehicle Reacquired
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_alert.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Airbag Deployed
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_accident.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Accident Reported
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_accident.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Open Recall
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_recall.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Vandalism Damage
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_magnifyingGlass.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Water Damage
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_magnifyingGlass.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Hail Damage
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_magnifyingGlass.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Fire Damage
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_magnifyingGlass.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Damage
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_magnifyingGlass.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Potential Odometer Rollback
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_rollback.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Multiple Owners
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_owner3.svg"} className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Non-Personal Vehicle
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_generic.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Minor Damage
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_minorDmg.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Minor Damage
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_information.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Minor Damage
                            </td>
                            <td>
                                <Image src={"https://partnerstatic.carfax.com/img/vhr/ico_orangeCar.svg"}
                                       className={"img-fluid"}/>
                            </td>
                        </tr>

                        </tbody>
                    </Table>

                </section>
                <hr/>
                <section>
                    <h3 id={"chbv-glossary"}>Glossary</h3>
                    <p>
                        The following glossary should be made available on screen to dealers using your application:
                    </p>
                    <p>
                        <strong>Values:</strong>
                        <ul>
                            <li>
                                Retail – I am selling this car at my dealership.
                            </li>
                            <li>
                                Certified – I am selling this car as a certified pre-owned vehicle at my dealership.
                            </li>
                            <li>
                                Wholesale – I am buying this car from an auction or as a trade-in vehicle.
                            </li>
                        </ul>
                    </p>
                    <p>
                        <strong>Condition:</strong>
                        <ul>
                            <li>
                                Excellent – As good as new with no cosmetic or mechanical flaws.
                            </li>
                            <li>
                                Good – No major mechanical problems and only minor cosmetic flaws.
                            </li>
                            <li>
                                Fair – Has cosmetic flaws and/or mechanical issues that may need to be repaired or
                                replaced.
                            </li>
                        </ul>
                    </p>
                    <p>
                        <strong>Zip Code:</strong> Cars are worth different amounts in different areas. Enter your zip
                        code for the most accurate value.
                    </p>
                    <p><strong>Odometer:</strong> CARFAX estimates the mileage of each vehicle. If you know the mileage
                        of this vehicle to be different than what is returned, supply the odometer.</p>
                    <p><strong>Trim:</strong> Most models are available in a variety of trim levels. If you know the
                        trim of this vehicle to be different than what is selected, update it to get the most accurate
                        value.</p>
                    <p><strong>Color:</strong> The color of a car can affect its resale value. If you know the color and
                        it’s available, select it.</p>
                    <p><strong>Features:</strong> These attributes impact the value. If you know the features on this
                        vehicle, select them below to get the most accurate value.</p>
                </section>
            </div>
        );
    }
}
